import jquery from "jquery"

function runBootstrapMethod(plugin, config, ...args) {
  return this.each(function () {
    const instance = plugin.getOrCreateInstance(this, typeof config === "object" ? config : undefined)

    if (typeof config === "string") {
      instance[config](...args)
    }
  })
}

jquery.fn.modal = function modal(config, ...args) {
  return runBootstrapMethod.call(this, window.bootstrap.Modal, config, ...args)
}

jquery.fn.tooltip = function tooltip(config, ...args) {
  return runBootstrapMethod.call(this, window.bootstrap.Tooltip, config, ...args)
}

jquery.fn.tab = function tab(config, ...args) {
  return runBootstrapMethod.call(this, window.bootstrap.Tab, config, ...args)
}
